import React from "react";
import MainPage from "./pages/MainPage";

const App = () => {
  return (
    <div className="App">
      <MainPage />
    </div>
  );
};

export default App;
